module.exports = __webpack_public_path__ + "static/media/TravelSearchVIOP.1a763faa.png";